import { fromJS } from 'immutable';

import { LOGIN_FAILED, RESET_LOGIN } from './constants';

export const initialState = fromJS({ loginRejected: false });

export default (state = initialState, action) => {
  switch (action.type) {
    case 'INIT':
    case RESET_LOGIN:
      return state.set('loginRejected', false);

    case LOGIN_FAILED:
      return state.set('loginRejected', true);

    default:
      return state;
  }
};
